export default {
    state:{
        status:1
    },
    mutations:{
        SET_STATUS(state,status){
            state.status=status
        }
    },
    actions:{
        setStatus({commit},status){
            commit('SET_STATUS',status)
        }
    }
}
